/**
 * Number Helpers
 *
 */

import invariant from 'invariant';
import memoize from 'lodash/memoize';

export const formatter = memoize(
  (config = { useGrouping: false, maximumFractionDigits: 0 }) =>
    // eslint-disable-next-line new-cap
    Intl.NumberFormat(undefined, config),
);

const suffixes = ['k', 'M', 'B', 'T'];
const calcSuffix = input => {
  let value = input;
  let suffix = '';
  for (
    let i = 0, j = suffixes.length;
    i < j && Math.abs(value) >= 1e3;
    i += 1
  ) {
    value /= 1000;
    suffix = suffixes[i];
  }

  return { value, suffix };
};

/**
 * Converts values to the units of the appropriate numeric suffix.
 * This applies to numbers < -1k && > 1k.
 * @param  {Number} number
 * @return {String}
 */
export const applyMetricSuffix = input => {
  invariant(
    !(typeof input === 'string' && isNaN(input)),
    `The value of "${input}" must be a number or a string of numerals.`,
  );

  const { value, suffix } = calcSuffix(input);
  const formatted =
    Math.abs(input) > 1e6
      ? formatter({ useGrouping: false, maximumFractionDigits: 2 }).format(
          value,
        )
      : formatter({ useGrouping: false, maximumFractionDigits: 1 }).format(
          value,
        );
  const output = `${formatted}${suffix}`;

  return output;
};

/**
 *
 * Converts a number to a string with appropriate delimiters
 *
 */

export const basicNumberFormatter = input => {
  invariant(
    !(typeof input === 'string' && isNaN(input)),
    `The value of "${input}" must be a number or a string of numerals.`,
  );

  return formatter({ useGrouping: true }).format(input);
};
